import { camelizeKeys } from "humps";
import { cmsClient } from "src/services/cmsClient";
import { ObservationCategoriesSchema as Schema } from "src/features/Admin/Observations/models";
import { useQuery } from "@tanstack/react-query";

const fetchObservationCategories = async () => {
	const url = "/observations/admin/forms/categories/";

	const response = await cmsClient.get(url);
	const camelizedData = camelizeKeys(response.data);

	return Schema.parse(camelizedData);
};

const useObservationCategories = () => {
	const queryKey = ["observation-categories"];
	const queryFn = fetchObservationCategories;

	const query = useQuery({
		queryKey,
		queryFn
	});

	return query;
};

export default useObservationCategories;
